<template>
  <div id="app" class="container-fluid py-3">
    <div v-if="!queryParams?.lang" class="lang-menu">
      <span v-for="(locale, idx) in locales"
            :key="locale"
      >
        <a href="#"
           :class="locale === $i18n.locale ? 'text-primary' : 'text-secondary'"
           @click.prevent="setAppLocale(locale)"
        >
          {{ locale.toUpperCase() }}
        </a>
        <span v-if="idx < locales.length - 1" class="px-1">|</span>
      </span>
    </div>
    <div v-if="queryParams?.show_logo" class="mb-3 text-center">
      <img :src="$config.LOGO_URL"
           class="img-fluid"
           style="max-height: 6em !important;"
           alt="Terminverwaltung ortho-kreissl.de"
      >
    </div>
    <router-view v-if="!loading"/>
    <loading-overlay v-else/>
  </div>
</template>

<script>
import ApiAppMixin from 'pixelstein-vue-app-package/src/mixins/api-app-mixin';
import AppCore     from '@/mixins/app-core';

import LoadingOverlay from '@/components/LoadingOverlay';

export default {
  name: 'App',
  components: {LoadingOverlay},
  mixins: [ApiAppMixin, AppCore],
  data() {
    return {
      loading: true,
    };
  },
  created() {

    const options = {
      $ignorePagination: true,
    };

    Promise.all([
      this.getLocations(options).catch(this.$apiErrorHandler),
      this.getAppointmentTypes(options).catch(this.$apiErrorHandler),
    ])
        .then(() => this.loading = false);

    this.$apiErrorHandlerPlugin.addMiddleware(apiError => {

      this.$toast.open({
        message: apiError.message,
        type: 'error',
        position: this.$config?.TOAST_POSITION ?? 'top',
      });

    });
  },
};
</script>

<style lang="scss">
@import "src/styles/main";
</style>
